import { render, staticRenderFns } from "./PacoteServicoSelect.vue?vue&type=template&id=6eaa3a24&"
import script from "./PacoteServicoSelect.vue?vue&type=script&lang=js&"
export * from "./PacoteServicoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports